// extracted by mini-css-extract-plugin
export default {"multi-option":"MultiOption_multi-option__C3ie+"};